import { Component, Input, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { environment, trackerUrl } from '@environments/environment';
import { Location } from '@angular/common';
import { pushToDataLayer } from '@helpers/gtm.util';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { HeadToHeadDialog } from './headtohead-dialog';
import { Subscription } from 'rxjs';
import { getUrlParams } from '../modules/getUrlParams';
import { DomSanitizer } from '@angular/platform-browser';
import { debounce } from 'lodash';
import { AppTimerService } from '@services/app-timer.service';
import { DeepValuePipe } from '@app/pipes/deepValue.pipe';
import { sportRadarWidgetLanguageList } from '@app/constants/sportRadar.constant';
import { OddModel } from '@app/models/odd.model';

declare let SIR: any;

@Component({
  selector: 'eventdetail-component',
  templateUrl: '../sharedTemplates/eventdetail.component.html',
  providers: [AppTimerService],
})
export class EventDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  deepValue = new DeepValuePipe();
  @ViewChild('search') search;
  originalList;
  filled = false;
  searchValue = ''; // Arama değerini saklamak için
  ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
  enableBetGeniusTracker = false;
  debounceAddCustomerTeamList: ((teamId: number) => void) & { cancel: () => void };
  constructor(
    private _location: Location,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    public _dataHelper: DataHelper,
    private route: ActivatedRoute,
    public _LZ: LocalizationService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private domSanitizer: DomSanitizer,
    private _TimerService: AppTimerService
  ) {
    const favIndexOf = this._UiHelper.favPreMatches.indexOf(this._DataHelper.selectedMatch);

    if (favIndexOf > -1) {
      this.isFavorite = true;
    } else {
      this.isFavorite = false;
    }
  }

  SIROBJ;

  @Input() eventIdByInput = 0;
  isFavorite = false;
  eventDetailTabItemSelected = 2;

  @Input() showScoreBoard = true;

  eventdetailList = [];
  orginallyEventDetailList = [];
  event;
  enableScoreBox = true;
  _selectedOdds: OddModel[] = [];
  public lsTrackerWidget;
  public isTracerMapped = true;
  widgetEl;
  eventid = 0;
  iconUrl = 'signal';
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  iframetrackerlink: any;

  ngOnInit() {
    if (this.eventIdByInput == 0) {
      this.subscriptionsToStopOnDestroy.push(
        this.route.params.subscribe(params => {
          this.eventid = params['eventid'];
          this.initialEventDetail();
        })
      );
    } else {
      this.eventid = this.eventIdByInput;
      this.initialEventDetail();
    }

    this._ApiService.getSelectedOdds();

    const urlParams = getUrlParams(window.location);

    console.log(urlParams);
    if (urlParams.has('odd')) {
      setTimeout(() => {
        this._ApiService.addOdd(urlParams.get('odd')).then(() => {
          this._ApiService
            .refreshCurrentSlip()
            .then()
            .catch(err => console.log('event-detail', err));
        });
      }, 1000);
    }
    if (environment.tracker_Operator === 'LS_Tracker') {
      this.renderLSTracker(this.eventid);
    }
  }

  ngAfterViewInit() {
    fromEvent(this.search.nativeElement, 'input')
      .pipe(
        debounceTime(500), // 500ms bekleme süresi
        map((event: any) => event.target.value)
      )
      .subscribe(searchTerm => {
        this.searchOdd(searchTerm);
      });
    // Scroll Top
    const elementList = document.querySelectorAll('.breadcrumb-left');
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
    // Scroll Top

    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      setTimeout(() => {
        this.renderLSTracker();
      }, 2000);
    }
    if (environment.isMyTeam) {
      this.getCustomerTeamList();
    }

    this.debounceAddCustomerTeamList = debounce(teamId => {
      this._ApiService.addCustomerTeamList(teamId).then(result => {
        if (result && result.length > 0) {
          if (result[0].resultcode == 104) {
            this.getCustomerTeamList();
          } else {
            this._UiHelper.errorSnackBar(result[0].resultmessage, '');

            return 'error|System Error';
          }
        }
      });
    }, 1000);
  }

  initialEventDetail() {
    if (this.eventid != 0) {
      this.getEventDetails(2);
    }

    this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });

    this._UiHelper.setNavbarTitle('Sports');
  }

  getEventDetails(groupId = 2) {
    this._ApiService
      .getEvent(this.eventid)
      .then(x => {
        if (x.length > 0) {
          this.event = x[0];
        }
        try {
          if (SIR != undefined && SIR != null) {
            this.SIROBJ = SIR('addWidget', '.sr-widget-2', 'match.lmtPlus', {
              layout: 'double',
              collapseTo: 'disable',
              detailedScoreboard: 'disable',
              pitchLogo: '',
              matchId: this.event.BetradarMatchId,
            });
            this.languageWidget();

            this.enableScoreBox = false;
          }
        } catch (e) {
          console.log('SIR is undefined');
        }
      })
      .catch(err => console.log('eventdetail', err));

    this._ApiService
      .getEventDetails(this.eventid, groupId)
      .then(x => {
        this.eventdetailList = x;
        this.originalList = x;
        //Filtreleme işlemi için ayrı bir arraye çektim datayı.
        this.orginallyEventDetailList = x;
      })
      .catch(err => console.log('eventdetail', err));
  }
  languageWidget(): void {
    SIR('changeLanguage', this.deepValue.transform(sportRadarWidgetLanguageList, [[this._LZ.LANGCODE], 'isoCode']) || 'en');
  }

  isOddSelected(oddType: any): boolean {
    return oddType?.eOdds?.some((odd: any) => this.checkOddId(odd.OddId) === 'active');
  }

  clickOdd(e) {
    if (!this._dataHelper.ChangeOddIsActive && environment.submitBetModifyControl) {
      return '';
    }

    this._ApiService.addOdd(e.OddId);
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else {
      return e;
    }
  }

  eventDetailTabItemChange(tabId: number) {
    this.eventDetailTabItemSelected = tabId;
    if (tabId != undefined) {
      this.eventdetailList = this.filterItemsByGroupId(this.eventDetailTabItemSelected);
    }
    if (this.eventdetailList && this.eventdetailList.length === 0) {
      this.getEventDetails(tabId);
    }
  }
  filterItemsByGroupId(groupId) {
    // GroupId 2 değilse, belirli bir GroupId'ye göre filtrele
    this.search.nativeElement.value = '';
    this.filled = false;
    if (groupId !== 2) {
      return this.orginallyEventDetailList.filter(item => {
        return item.GroupId && item.GroupId.split(',').some(id => id.trim() === String(groupId));
      });
    } else {
      return this.orginallyEventDetailList;
    }

    //Tab değişikliklerinde searchbarın kapatılmasını sağlıyorum.
  }

  goBack() {
    let iseventİd = 0;
    this.route.params.subscribe(params => {
      iseventİd = params['eventid'];
    });
    if (iseventİd != undefined && iseventİd != 0) {
      this._location.back();
    } else {
      try {
        if (SIR != undefined && SIR != null) {
          this.SIROBJ = SIR('removeWidget', '.sr-widget-2');
          this.languageWidget();
        }
      } catch (e) {
        console.error('event-detail', e);
      }
      this._UiHelper.p1001SetMatchDetailDialog('close');
    }
  }

  ScrollToTop() {
    const elementList = document.querySelectorAll('#detailDialog');
    const element = elementList[0] as HTMLElement;
    if (element != null) {
      element.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (element.scrollTop === 0) {
      this.goBack();
    }
  }

  addMatch2Favs(): void {
    if (this._UserHelper.isSignedIn) {
      this._DataHelper.setFavList(this.eventid * 1);
    }
  }
  addOdd2Favs(oddTypeId: number): void {
    const favorites = JSON.parse(localStorage.getItem('favoritedOdd') || '[]');
    const index = favorites.indexOf(oddTypeId);

    if (index > -1) {
      favorites.splice(index, 1); // Remove from favorites
    } else {
      favorites.push(oddTypeId); // Add to favorites
    }

    localStorage.setItem('favoritedOdd', JSON.stringify(favorites));
    this.updateList();
  }
  isOddFavorite(oddId: number): boolean {
    const favorites = JSON.parse(localStorage.getItem('favoritedOdd') || '[]');
    return favorites.includes(oddId);
  }
  updateList(): void {
    // Listenin bir kopyasını oluşturun ve yeniden atayın
    this.eventdetailList = [...this.eventdetailList];
  }
  openHeadToHeadDialog(): void {
    const dialogRef = this.dialog.open(HeadToHeadDialog, {
      maxWidth: '100%',
      width: '100%',
      height: '95%',
      maxHeight: '95%',
      panelClass: 'h2hDialogClass',
      data: { matchId: this.event.BetradarMatchId },
    });
  }

  element;
  renderLSTracker(eventId?) {
    if (eventId == undefined) {
      eventId = this.eventid;
    }

    this.element = document.getElementById('lsSportWrapperElem');
    const groupId = environment.tracker_GroupId;
    const inputData = { eventId: `m:${eventId}`, language: 'en', providerId: environment.tracker_ProviderId };
    if (eventId.toString().includes('-')) {
      inputData.eventId = `m:${eventId.toString().split('-')[1]}`;
      inputData.providerId = 109;
    }
    const options = {};
    const widget = new window.STATSCOREWidgets.WidgetGroup(this.element, groupId, inputData, options);
    this.lsTrackerWidget = widget;
  }

  ngOnDestroy() {
    this.SIROBJ = SIR('removeWidget', '.sr-widget-2');
    this.SIROBJ = null;
    this.eventid = null;

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    if (this.lsTrackerWidget && this.lsTrackerWidget.destroy) {
      try {
        this.lsTrackerWidget.destroy();
      } catch (e) {
        console.log(e);
      }
    }
    this.debounceAddCustomerTeamList.cancel();
  }
  addCustomerTeamList(teamId) {
    this._ApiService.addCustomerTeamList(teamId).then(result => {
      if (result && result.length > 0) {
        if (result[0].resultcode == 104) {
          this._UiHelper.successSnackBar(result[0].resultmessage, '');
          this.getCustomerTeamList();
        } else {
          this._UiHelper.errorSnackBar(result[0].resultmessage, '');

          return 'error|System Error';
        }
      }
    });
  }

  getCustomerTeamList() {
    this._ApiService.getCustomerTeamList().then(x => {
      this.setTeamChecked();
    });
  }
  isFirstFlag = true;
  setTeamChecked() {
    if (this.event) {
      this.event.HomeTeamChecked = false;
      this.event.AwayTeamChecked = false;

      for (const competitor of this._UiHelper.customerMyTeamData) {
        if (competitor.CompetitorId === this.event.HomeTeamId) {
          this.event.HomeTeamChecked = true;
        } else if (competitor.CompetitorId === this.event.AwayTeamId) {
          this.event.AwayTeamChecked = true;
        }
      }
      this._TimerService.setTimer('isFirstFlag', () => (this.isFirstFlag = false), 500);
    }
  }
  onIconClick() {
    const iconType = this.iconUrl === 'star' ? 'star' : 'signal';
    if (iconType === 'star') {
      pushToDataLayer({ event: 'fixture_list_star_click' });
    } else if (iconType === 'signal') {
      pushToDataLayer({ event: 'fixture_list_signal_click' });
    }
  }
  searchOdd(searchTerm) {
    let filteredList;
    if (searchTerm.length >= 3) {
      filteredList = this.originalList.filter(item => {
        const groupNamePart = item.GroupName.split('|')[1] || '';
        return groupNamePart.toLowerCase().includes(searchTerm.toLowerCase());
      });
      this.eventdetailList = [];
      this.eventdetailList = filteredList;
    } else {
      this.eventdetailList = this.originalList;
    }
  }
  openSearchBar() {
    if (this.eventDetailTabItemSelected !== 2) {
      this.eventDetailTabItemChange(2);
    }
    this.filled = !this.filled;
    this.searchValue = ''; // Her açılışta arama değerini sıfırla
    this.searchOdd(this.searchValue);
  }
}
